export interface IHouseholdOutgoingsForm {
  childcare: string;
  hasChildcare: null | string;
  educationFees: string;
  hasEducationFees: null | string;
  maintenance: string;
  hasMaintenance: null | string;
}

export enum YesNoEnum {
  YES = 'YES',
  NO = 'NO',
}
